import React from 'react';
import Loader from '../Loader.jsx';

export default class FacebookPageEmbed extends React.PureComponent {
  static propTypes = {
    name: React.PropTypes.string.isRequired,
    title: React.PropTypes.string.isRequired,
  };

  componentDidMount() {
    const FB = window.FB || null;
    if (FB) FB.XFBML.parse(this.refs.root);
  }

  render() {
    return (
      <div ref="root">
        <Loader className="facebook-embed-loader"/>
        <div
          className="fb-page facebook-page-embed"
          data-href={`www.facebook.com/${this.props.name}`}
          data-small-header="true"
          data-adapt-container-width="true"
          data-hide-cover="false"
          data-show-facepile="false"
        >
          <div className="fb-xfbml-parse-ignore">
            <blockquote cite={`www.facebook.com/${this.props.name}`}>
              <a href={`www.facebook.com/${this.props.name}`}>{this.props.title}</a>
            </blockquote>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Page/FacebookPageEmbed.jsx